import { Alert } from '@cobliteam/ui/components';
import axios from 'axios';
import JSZip from 'jszip';
import { useState } from 'react';

const useDownload = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  async function handleZip(images: string[], fileName = 'download') {
    setIsDownloading(true);
    const zip = new JSZip();

    // Add images to the zip file
    try {
      for (const image of images) {
        const response = await axios.get(image, {
          responseType: 'blob',
          headers: {
            'Content-Type': 'application/octet-stream',
            'Cache-Control': 'no-cache',
          },
        });
        const fileName = image.split('/').pop() || '';
        zip.file(fileName, response.data);
      }
    } catch (error) {
      setIsDownloading(false);
      Alert.error('Erro ao baixar as fotos. Por favor, tente novamente mais tarde.');
      return;
    }

    const zipData = await zip.generateAsync({
      type: 'blob',
      streamFiles: true,
    });

    // Create a download link for the zip file
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(zipData);
    link.download = `${fileName}.zip`;
    link.click();
    setIsDownloading(false);
  }

  return { handleZip, isDownloading };
};

export default useDownload;
